import { kbToByte } from '../../utils'

export const ImageSizes = {
  '450x450': {
    width: 450,
    height: 450,
    size: '400KB',
    byte: kbToByte(400),
  },
  '348x230': {
    width: 348,
    height: 230,
    size: '500KB',
    byte: kbToByte(500),
  },
  '1200x380': {
    width: 1200,
    height: 380,
    size: '500KB',
    byte: kbToByte(500),
  },
}
